import axios from 'axios'
import { buildRequestPrerequisites } from './dataService'

export const getCobrandingOEMImage = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })
  const { groupKey, itemKey = 'cobranding_landing_page.png' } = params
  const url = `${baseUrl}/webfile/groupKey/${groupKey}`
  try {
    const { data } = await axios.get(url, {
      headers,
      params: {
        api_key: apiKey,
        itemKey
      }
    })
    return {
      data,
      error: null
    }
  } catch (error) {
    return { data: null, error }
  }
}
  
